@if (redesSociais().length > 0) {
<div class="redes-sociais" aria-label="Redes sociais">
  @for (rede of redesSociais(); track $index) {
    <a
      class="redes-sociais-link"
      [href]="rede.link"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="rede.rotulo + ' (abre em nova aba)'"
    >
      <i [class]="rede.icone" aria-hidden="true"></i>
    </a>
  }
</div>
}
